<ion-header>
  <ion-toolbar>
    <ion-title>promotions-yoga</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
 <h3> nothing to show here</h3>
</ion-content>
